import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ad00891"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dw-header" }
const _hoisted_2 = { class: "dw-header__container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dw-header__title" }, "Рабочее окно диспетчера", -1))
const _hoisted_4 = { class: "dw-header__container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dw_button = _resolveComponent("dw-button")!
  const _component_dw_date = _resolveComponent("dw-date")!
  const _component_dw_select = _resolveComponent("dw-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_dw_button, { onClick: _ctx.onGoToBpms }, {
        default: _withCtx(() => [
          _createTextVNode("Назад в BPMS")
        ]),
        _: 1
      }, 8, ["onClick"]),
      _hoisted_3
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_dw_button, {
        loading: _ctx.loading,
        disabled: _ctx.loading,
        onClick: _ctx.onReload
      }, {
        default: _withCtx(() => [
          _createTextVNode("Обновить")
        ]),
        _: 1
      }, 8, ["loading", "disabled", "onClick"]),
      _createVNode(_component_dw_button, { onClick: _ctx.onOpenSelfPickup }, {
        default: _withCtx(() => [
          _createTextVNode("Самовывоз")
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_dw_button, { onClick: _ctx.onOpenSelfDelivery }, {
        default: _withCtx(() => [
          _createTextVNode("Самопривоз")
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_dw_date, {
        placeholder: "Выбрать дату",
        value: _ctx.date,
        disabled: _ctx.dispatcherSectorsLoading,
        onChange: _ctx.onDateChanged
      }, null, 8, ["value", "disabled", "onChange"]),
      _createVNode(_component_dw_select, {
        placeholder: "Выбрать сектор диспетчера",
        value: _ctx.dispatcherSectorId,
        disabled: _ctx.dispatcherSectorsLoading,
        loading: _ctx.dispatcherSectorsLoading,
        failed: _ctx.dispatcherSectorsFailed,
        options: _ctx.dispatcherSectors,
        onChange: _ctx.onDispatcherSectorChanged
      }, null, 8, ["value", "disabled", "loading", "failed", "options", "onChange"])
    ])
  ]))
}